export const VR_TRIGGER_OPTIONS = [
  'grip_pressed',
  'trigger_pressed',
  'touchpad_touched',
  'gaze_enter',
  'gaze_exit',
  'controller_hover',
  'pinch_gesture',
  'point_gesture',
];

export const ASSET_MODEL_OPTIONS = ['Mesh', 'Audio', 'Text', 'Video', 'Image'];

export const NODE_TYPES = {
  root: 'root',
  category: 'category',
  subCategory: 'subCategory',
  property: 'property',
  trigger: 'trigger',
  action: 'action',
  eventContainer: 'eventContainer',
};

export const EVENT_MODES = {
  ADD: 'add',
  ADD_TRIGGER: 'add-trigger',
  ADD_ACTION: 'add-action',
  EDIT: 'edit',
};

export const Y_SPACING = 150;
export const X_SPACING = 250; // Horizontal spacing between nodes
export const MIN_EVENT_SPACING = 400;
export const POSITION_SAVE_DEBOUNCE = 500;
export const NODE_WIDTH = 200; // Estimated node width for collision detection
export const NODE_HEIGHT = 100; // Estimated node height for collision detection
